<template>
  <div
    class="page page-result page-subtree-assist-operation-result"
    :style="{ paddingTop: titleHeight + 'px' }"
  >
    <div class="status">
      <img
        v-if="status == 1"
        src="@/assets/img/assist-operation/img_pass@2x.png"
      />
      <img v-else src="@/assets/img/assist-operation/img_reject@2x.png" />
      <div class="text">{{ status == 1 ? '提交成功' : '提交失败' }}</div>
      <div v-if="status != 1" class="desc"></div>
    </div>
    <div v-if="status != 1" class="custom-button">
      <div class="btn active" @click="back">再次提交</div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      status: 1 // 0 失败 1 成功
    }
  },
  computed: {
    titleHeight() {
      return this.$store.state.titleHeight || 0
    }
  },
  mounted() {},
  methods: {
    back() {
      this.$router.replace({
        name: 'merchant-manage-assist-operation'
      })
    }
  }
}
</script>
